import type { K8sTargetType } from '@/config/views/monitoring/log/utils/types';
import type { TagRequest } from '@/api-client/log/model';

export const K8S_TARGET_TYPE: (K8sTargetType | '')[] = [
  'daemonset',
  'cronjob',
  'deployment',
  'statefulset',
  'replicaset',
];

export const SUPPORTED_ES_CATEGORIES_KUBERNETES = K8S_TARGET_TYPE;

export const SUPPORTED_ES_CATEGORIES = [
  'host',
  ...K8S_TARGET_TYPE,
  // Note 삼성 범위에서 제외
  // 'database',
];

export const LOG_TREND_ERROR_TYPE = {
  ES_EXECUTE_ERROR: 'ElasticSearchExecuteException',
  ES_LUCENE_ERROR: 'ElasticSearchLuceneQueryExecuteException',
  ES_UNEXPECTED_EXCEPTION: 'ElasticSearchUnexpectedException',
  ES_SERVER_EXCEPTION: 'ElasticSearchServerException',
};

export const DEFAULT_SPARSE_RATE_DATA = {
  rate: 0.000001, // 0.0001%
  color: 'rgba(122, 217, 39, 1)',
  isOnly: false,
};

export const DEFAULT_TEMPLATE_HASH = '';

export const ALL_TAGS: TagRequest[] = [
  {
    tagType: 'tag',
    tagKey: 'host',
    tagValue: ['*'],
  },
  ...K8S_TARGET_TYPE.map<TagRequest>((type) => ({
    tagType: 'tag',
    tagKey: type,
    tagValue: ['*'],
  })),
  // Note 삼성 범위에서 제외
  // {
  //   tagType: 'tag',
  //   tagKey: 'database',
  //   tagValue: ['*'],
  // },
];

// Note: 화면 최대 누적 갯수
export const LOGGING_TREND_ROW_MAX = 100_000;
